<template>
  <section class="filters-section"
    :class="{
      '_pt': route.path !== '/',
      '_show-map': query.showMap
     }">
    <!-- ФИЛЬТРЫ БАННЕР -->
    <div class="filters-wrapper">

      <div v-if="route.path !== '/'"
        class="filters-section__main-banner">
        <div class="main-banner">
          <div class="main-banner__image">
            <img :src="heroImage" :alt="heroTitle">
          </div>
          <div class="main-banner__content">
            <h2>{{ heroTitle }}</h2>
          </div>
        </div>
      </div>

      <div 
        ref="filters"
        class="filters"
        :class="{ '_show-all': query.showAllFilters }">
        <!-- КУПИТЬ/СНЯТЬ -->
        <FIlterEstateTypeBuyOrRentReactive />
        <!-- ОСНОВНЫЕ ФИЛЬТРЫ -->
        <div ref="upperFilters"
          class="filters__body"
          style="z-index: 110">
          <div class="filters__row">
            <FilterAllCategoryReactive v-if="route.path === '/'"
              class="filters__filter"
              :is-filter-head="true"
              @click="closeAccordions" />
            <template v-if="query.currentEstateType.name === 'Вторичная недвижимость'">
              <FilterCategoryReactive class="filters__filter"
                :is-filter-head="true"
                @click="closeAccordions" />
            </template>
            <FilterRoomReactive v-if="![5,8].includes(query.category[0])"
              class="filters__filter"
              :is-filter-head="true"
              @click="closeAccordions" />
          </div>
          <div class="filters__row">
            <FilterPrice class="filters__filter _price" />
          </div>
          <div class="filters__row filters__row-mobile">
            <FilterCityReactive class="filters__filter _select" />
            <FilterAreaReactive class="filters__filter _select"
              :disabled="query.subLocalitiesAreDisabled" />
          </div>
          <div v-if="query.currentEstateType.name === 'Новостройки'"
            class="filters__wrapper">
            <FilterReadyReactive class="filters__filter"
              :is-filter-head="true"
              title="Срок сдачи"
              @click="closeAccordions" />
            <FilterPrice class="filters__filter _price" />
            <div class="filters__row">
              <FilterCityReactive class="filters__filter _select"
                :is-filter-head="true"
                @click="closeAccordions" />
              <FilterAreaReactive class="filters__filter _select"
                :is-filter-head="true"
                :disabled="query.subLocalitiesAreDisabled"
                @click="closeAccordions" />
            </div>
            <FilterZHKReactive class="filters__filter _select" />
          </div>
          <div v-if="query.currentEstateType.name === 'Загородная'"
            style="align-self: stretch;">
            <FilterCategoryReactive class="filters__filter"
              :category-list="query.offerCategories.resaleEstate"
              :is-filter-head="true"
              @click="closeAccordions" />
            <template v-if="false">
              <FilterPrice class="filters__filter _price" />
              <FilterCityReactive class="filters__filter _select" />
              <FilterAreaReactive class="filters__filter _select"
              :disabled="query.subLocalitiesAreDisabled" />
            </template>


          </div>
          <div v-if="query.currentEstateType.name === 'Коммерческая'"
            class="filters__wrapper">
            <FilterPurposeReactive class="filters__filter"
              :is-filter-head="true"
              title="Вид объекта"
              @click="closeAccordions" />
            <FilterPrice :key="filterKey"
              class="filters__filter _price" />
            <FilterCityReactive class="filters__filter _select" />
            <FilterAreaReactive class="filters__filter _select"
              :disabled="query.subLocalitiesAreDisabled" />
            <FilterSquareAreaMeters class="filters__filter"
              :is-filter-head="true"
              @click="closeAccordions" />
            <AppButton 
              @click="goToPageAndSearch">
              Поиск
            </AppButton>
            <div class="filters__action filters__action--clear reset"
              @click="clearFilters('FROM_MAIN')">
              СБРОСИТЬ
            </div>
          </div>
          <div v-if="query.currentEstateType.name !== 'Коммерческая'"
            ref="bottomFilters"
            class="filters__bottom">
            <div v-if="query.currentEstateType.name === 'Вторичная недвижимость'"
              class="filters__wrapper">
              <div class="filters__row filters__row-mobile">
                <FilterFloor class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterSquareReactive v-if="query.minSquareRange"
                  class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
              </div>
              <div class="filters__row filters__row-mobile">
                <FilterKitchen class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterNewFlat />
              </div>
            </div>
            <div v-if="query.currentEstateType.name === 'Новостройки'"
              class="filters__wrapper">
              <FilterFurnish class="filters__filter"
                :is-filter-head="true"
                @click="closeAccordions" />
            </div>
            <div v-if="query.currentEstateType.name === 'Загородная'"
              class="filters__wrapper">
              <div class="filters__row filters__row-mobile">
                <FilterSquareReactive class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterSquareAreaReactive class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
              </div>
                <FilterRoadDistanceReactive class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />

              <div class="filters__filter">
                <FilterCountryButtons />
              </div>
            </div>
            <!-- <div v-if="query.currentEstateType.name !== 'Коммерческая'"
              class="filters__action filters__action--clear"
              @click="clearFilters('FROM_MAIN')">
              СБРОСИТЬ
            </div> -->
          </div>
          <div v-if="query.currentEstateType.name !== 'Коммерческая'"
            class="filters__actions">
            <div class="filters__action filters__action--show-all"
              @click="toggleFilters">
              <span>Все фильтры</span>
              <app-svg id="arrow-bottom"
                width="12"
                height="6" />
            </div>
            <AppButton v-if="query.currentEstateType.name !== 'Коммерческая' && query.route === '/'"
              @click="goToPageAndSearch">
              Поиск
            </AppButton>
          </div>
        </div>
        <!-- ДОП ФИЛЬТРЫ-->
      </div>
      
      <div class="filters-icons"
        v-if="route.path === '/' && mainLinks.length">
        <h2>Агентство недвижимости</h2>
        <div class="filters-icons__list">
          <router-link 
            :to="item.link"
            class="filters-icons__item"
            v-for="(item, idx) in mainLinks"
            :key="item.link">
            <AppSvg :id="icons[idx]"
              class="filters-icons__icon"></AppSvg>
            <AppSvg :id="`${icons[idx]}-hover`"
              class="filters-icons__icon _hover"></AppSvg>
            {{ item.name }}
          </router-link>
        </div>
      </div>
    </div>

    <!-- ФИЛЬТРЫ КАРТА -->
    <!-- <Teleport :disabled="!query.showMobileMap"
      to="body">
      <div class="mobile-modal-map"
        :class="{ _active: query.showMobileMap }">
        <div class="mobile-actions"
          :class="{ _hide: curCard }">
          <div class="mobile-actions__inner">
            <AppButton :with-logo="true"
              @click="openMobileFilters">
              Фильтры
            </AppButton>

            <AppButton :fourth="true"
              :class="{ _white: query.showMobileMap }"
              @click="showMobileMap()">
              {{ query.showMobileMap ? "Cписком" : "Карта" }}
            </AppButton>
          </div>
        </div>

        <section v-if="query.showMobileMap || query.showMap"
          class="map"
          :class="{ '_show-all-map': query.showAllFilters }">
          <div class="map__inner">
            <div class="map__content">
              <AppToggle class="map__toggle"
                label="Показать на карте"
                checked
                @change="toggleMap" 
                like-icon="location"
                />
              <div ref="filters"
                class="map__filters filters _map-filter">

                <div class="filters__head">
                  <FIlterEstateTypeBuyOrRentReactive />
                </div>

                <div ref="upperFilters"
                  class="filters__body"
                  style="z-index: 109">
                  <FilterAllCategoryReactive v-if="route.path === '/'"
                    class="filters__filter"
                    :is-filter-head="true"
                    @click="closeAccordions" />
                  <div v-if="query.currentEstateType.name === 'Вторичная недвижимость'"
                    class="filters__wrapper">
                    <FilterCategoryReactive class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterRoomReactive v-if="query.category[0] !== 5"
                      class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterPrice class="filters__filter _price" />
                    <FilterCityReactive class="filters__filter _select" />
                    <FilterAreaReactive class="filters__filter _select _select-map-filter" />
                  </div>

                  <div v-if="query.currentEstateType.name === 'Новостройки'"
                    class="filters__wrapper">
                    <FilterReadyReactive class="filters__filter"
                      :is-filter-head="true"
                      title="Срок сдачи"
                      @click="closeAccordions" />
                    <FilterPrice class="filters__filter _price" />
                    <FilterCityReactive class="filters__filter _select"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterAreaReactive class="filters__filter _select _select-map-filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterZHKReactive class="filters__filter _select _select-map-filter" />
                  </div>

                  <div v-if="query.currentEstateType.name === 'Загородная'"
                    class="filters__wrapper">
                    <FilterCategoryReactive class="filters__filter"
                      :category-list="query.offerCategories.resaleEstate"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterPrice class="filters__filter _price" />
                    <FilterCityReactive class="filters__filter _select" />
                    <FilterAreaReactive class="filters__filter _select _select-map-filter" />
                  </div>

                  <div v-if="query.currentEstateType.name === 'Коммерческая'"
                    class="filters__wrapper">
                    <FilterPurposeReactive class="filters__filter"
                      :is-filter-head="true"
                      title="Вид объекта"
                      @click="closeAccordions" />
                    <FilterPrice class="filters__filter _price" />
                    <FilterCityReactive class="filters__filter _select" />
                    <FilterAreaReactive class="filters__filter _select _select-map-filter" />
                    <FilterSquareAreaMeters class="filters__filter _select-map-filter _area-metars-map-filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />

                  </div>

                  <div v-if="query.showAllFilters && query.currentEstateType.name === 'Вторичная недвижимость'"
                    class="filters__wrapper">
                    <FilterFloor class="filters__filter _floor-filter-map"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterSquareReactive v-if="query.minSquareRange"
                      class="filters__filter _square-filter-map"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterKitchen class="filters__filter _kitchen-filter-map"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterNewFlat class="_flat-filter-map" />
                  </div>
                  <div v-if="query.showAllFilters && query.currentEstateType.name === 'Новостройки'"
                    class="filters__wrapper">
                    <FilterFurnish class="filters__filter _furnish-filter-map"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                  </div>
                  <div v-if="query.showAllFilters && query.currentEstateType.name === 'Загородная'"
                    class="filters__wrapper">
                    <FilterSquareReactive class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterSquareAreaReactive class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterRoomReactive v-if="query.category[0] !== 5"
                      class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterRoadDistanceReactive class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <div class="filters__filter _checks">
                      <FilterCountryButtons />
                    </div>
                  </div>

                  <div class="filters__actions-wrapper">
                    <div style="color: #c8cccf"
                      :style="{
                        marginTop: query.currentEstateType.name === 'Коммерческая' ? '10px' : '',
                        marginBottom: query.currentEstateType.name === 'Коммерческая' ? '10px' : '',
                      }"
                      class="filters__action filters__action--clear"
                      @click="clearFilters('FROM_MAIN')">
                      СБРОСИТЬ
                    </div>
                    <div v-if="query.currentEstateType.name !== 'Коммерческая'"
                      class="filters__action filters__action--show-all _hover-white"
                      @click="toggleFilters">
                      <span style="color: #ff823c">Все фильтры</span>
                      <app-svg id="arrow-bottom"
                        :class="{ _active: query.showAllFilters }"
                        width="12"
                        height="6" />
                    </div>
                  </div>

                  <AppButton v-if="query.route === '/'"
                    @click="goToPageAndSearch">
                    Поиск
                  </AppButton>
                </div>
              </div>
              <MapMainFilterYandex v-if="query.showMap"
                ref="yandexmap"
                :show-map-mobile="query.showMobileMap"
                :show-mobile-map="showMobileMap"
                @changeCurCard="changeCurCard" />
            </div>
          </div>
        </section>
      </div>
    </Teleport> -->

    <!-- Мобайл фильтры -->
    <teleport to="body">
      <TransitionTranslateLeft>
        <div v-if="query.filterMobileMenuIsOpen"
          ref="filter-menu"
          class="mobile-filter-menu">
          <div class="mobile-filter-menu__head">
            <span @click="closeMobileFilters">
              <app-svg id="arrow-left"
                width="6"
                height="12" />
              назад
            </span>
            <span>Фильтр</span>
            <span @click="clearFilters('FROM_MAIN')">Сбросить</span>
          </div>

          <div ref="filters"
            class="mobile-filter-menu__body filters _map-filter"
            :class="{ '_show-all': query.showAllFilters }">
            <!-- КУПИТЬ/СНЯТЬ -->
            <div class="filters__head">
              <FIlterEstateTypeBuyOrRentReactive />
            </div>

            <!-- ОСНОВНЫЕ ФИЛЬТРЫ -->
            <div ref="upperFilters"
              class="filters__body"
              style="z-index: 108">
              <FilterAllCategoryReactive v-if="route.path === '/'"
                class="filters__filter _select"
                :is-filter-head="true"
                @click="closeAccordions" />
              <div v-if="query.currentEstateType.name === 'Вторичная недвижимость'"
                class="filters__wrapper">
                <FilterCategoryReactive class="filters__filter _select"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterRoomReactive v-if="query.category[0] !== 5"
                  class="filters__filter _select"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterPrice class="filters__filter _price" />
                <FilterCityReactive class="filters__filter _select" />
                <FilterAreaReactive :disabled="query.subLocalitiesAreDisabled"
                  class="filters__filter _select" />
              </div>
              <div v-if="query.currentEstateType.name === 'Новостройки'"
                class="filters__wrapper">
                <FilterReadyReactive class="filters__filter"
                  :is-filter-head="true"
                  title="Срок сдачи"
                  @click="closeAccordions" />
                <FilterPrice class="filters__filter _price" />
                <FilterCityReactive :is-filter-head="true"
                  class="filters__filter _select"
                  @click="closeAccordions" />
                <FilterAreaReactive :is-filter-head="true"
                  :disabled="query.subLocalitiesAreDisabled"
                  class="filters__filter _select"
                  @click="closeAccordions" />
                <FilterZHKReactive class="filters__filter _select" />
              </div>
              <div v-if="query.currentEstateType.name === 'Загородная'"
                class="filters__wrapper">
                <FilterCategoryReactive :category-list="query.offerCategories.resaleEstate"
                  class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterPrice class="filters__filter _price" />
                <FilterCityReactive class="filters__filter _select" />
                <FilterAreaReactive :disabled="query.subLocalitiesAreDisabled"
                  class="filters__filter _select" />
              </div>
              <div v-if="query.currentEstateType.name === 'Коммерческая'"
                class="filters__wrapper">
                <FilterPurposeReactive class="filters__filter"
                  :is-filter-head="true"
                  title="Вид объекта"
                  @click="closeAccordions" />
                <FilterPrice :key="filterKey"
                  class="filters__filter _price" />
                <FilterCityReactive class="filters__filter _select" />
                <FilterAreaReactive :disabled="query.subLocalitiesAreDisabled"
                  class="filters__filter _select" />
                <FilterSquareAreaMeters :is-filter-head="true"
                  class="filters__filter"
                  @click="closeAccordions" />
                <!-- <AppButton style="margin-top: 10px" v-if="query.route === '/'" @click="goToPageAndSearch">
                  Поиск
                </AppButton> -->
              </div>
              <div class="filters__actions-wrapper">
                <div v-if="query.currentEstateType.name !== 'Коммерческая'"
                  class="filters__action filters__action--show-all"
                  @click="toggleFilters">
                  <span> Все фильтры</span>
                  <app-svg id="arrow-bottom"
                    width="12"
                    height="6" />
                </div>
              </div>
            </div>
            <!-- ДОП ФИЛЬТРЫ-->
            <div v-if="query.showAllFilters"
              ref="bottomFilters"
              class="filters__body"
              style="z-index: 107">
              <div v-if="query.currentEstateType.name === 'Вторичная недвижимость'"
                class="filters__wrapper">
                <FilterFloor class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterSquareReactive v-if="query.minSquareRange"
                  class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterKitchen class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterNewFlat />
              </div>

              <div v-if="query.currentEstateType.name === 'Новостройки'"
                class="filters__wrapper">
                <FilterFurnish class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
              </div>

              <div v-if="query.currentEstateType.name === 'Загородная'"
                class="filters__wrapper">
                <FilterSquareReactive class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterSquareAreaReactive class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterRoomReactive v-if="query.category[0] !== 5"
                  class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <FilterRoadDistanceReactive class="filters__filter"
                  :is-filter-head="true"
                  @click="closeAccordions" />
                <div class="filters__filter _checks">
                  <FilterCountryButtons />
                </div>
              </div>
            </div>
            <AppButton style="width: 100%; margin-bottom: 56px"
              @click="closeMobileFiltersAndSearch">
              Показать
            </AppButton>
          </div>
        </div>
      </TransitionTranslateLeft>
    </teleport>

    <div class="filters-section__content">
      <section v-if="query.showMobileMap || query.showMap"
          class="map"
          :class="{ '_show-all-map': query.showAllFilters }">
          <div class="map__inner">
            <div class="map__content">
              <AppToggle class="map__toggle"
                label="Показать на карте"
                checked
                @change="toggleMap" 
                like-icon="location"
                />
              <!-- <div ref="filters"
                class="map__filters filters _map-filter">

                <div class="filters__head">
                  <FIlterEstateTypeBuyOrRentReactive />
                </div>

                <div ref="upperFilters"
                  class="filters__body"
                  style="z-index: 109">
                  <FilterAllCategoryReactive v-if="route.path === '/'"
                    class="filters__filter"
                    :is-filter-head="true"
                    @click="closeAccordions" />
                  <div v-if="query.currentEstateType.name === 'Вторичная недвижимость'"
                    class="filters__wrapper">
                    <FilterCategoryReactive class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterRoomReactive v-if="query.category[0] !== 5"
                      class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterPrice class="filters__filter _price" />
                    <FilterCityReactive class="filters__filter _select" />
                    <FilterAreaReactive class="filters__filter _select _select-map-filter" />
                  </div>

                  <div v-if="query.currentEstateType.name === 'Новостройки'"
                    class="filters__wrapper">
                    <FilterReadyReactive class="filters__filter"
                      :is-filter-head="true"
                      title="Срок сдачи"
                      @click="closeAccordions" />
                    <FilterPrice class="filters__filter _price" />
                    <FilterCityReactive class="filters__filter _select"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterAreaReactive class="filters__filter _select _select-map-filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterZHKReactive class="filters__filter _select _select-map-filter" />
                  </div>

                  <div v-if="query.currentEstateType.name === 'Загородная'"
                    class="filters__wrapper">
                    <FilterCategoryReactive class="filters__filter"
                      :category-list="query.offerCategories.resaleEstate"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterPrice class="filters__filter _price" />
                    <FilterCityReactive class="filters__filter _select" />
                    <FilterAreaReactive class="filters__filter _select _select-map-filter" />
                  </div>

                  <div v-if="query.currentEstateType.name === 'Коммерческая'"
                    class="filters__wrapper">
                    <FilterPurposeReactive class="filters__filter"
                      :is-filter-head="true"
                      title="Вид объекта"
                      @click="closeAccordions" />
                    <FilterPrice class="filters__filter _price" />
                    <FilterCityReactive class="filters__filter _select" />
                    <FilterAreaReactive class="filters__filter _select _select-map-filter" />
                    <FilterSquareAreaMeters class="filters__filter _select-map-filter _area-metars-map-filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />

                  </div>

                  <div v-if="query.showAllFilters && query.currentEstateType.name === 'Вторичная недвижимость'"
                    class="filters__wrapper">
                    <FilterFloor class="filters__filter _floor-filter-map"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterSquareReactive v-if="query.minSquareRange"
                      class="filters__filter _square-filter-map"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterKitchen class="filters__filter _kitchen-filter-map"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterNewFlat class="_flat-filter-map" />
                  </div>
                  <div v-if="query.showAllFilters && query.currentEstateType.name === 'Новостройки'"
                    class="filters__wrapper">
                    <FilterFurnish class="filters__filter _furnish-filter-map"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                  </div>
                  <div v-if="query.showAllFilters && query.currentEstateType.name === 'Загородная'"
                    class="filters__wrapper">
                    <FilterSquareReactive class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterSquareAreaReactive class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterRoomReactive v-if="query.category[0] !== 5"
                      class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <FilterRoadDistanceReactive class="filters__filter"
                      :is-filter-head="true"
                      @click="closeAccordions" />
                    <div class="filters__filter _checks">
                      <FilterCountryButtons />
                    </div>
                  </div>

                  <div class="filters__actions-wrapper">
                    <div style="color: #c8cccf"
                      :style="{
                        marginTop: query.currentEstateType.name === 'Коммерческая' ? '10px' : '',
                        marginBottom: query.currentEstateType.name === 'Коммерческая' ? '10px' : '',
                      }"
                      class="filters__action filters__action--clear"
                      @click="clearFilters('FROM_MAIN')">
                      СБРОСИТЬ
                    </div>
                    <div v-if="query.currentEstateType.name !== 'Коммерческая'"
                      class="filters__action filters__action--show-all _hover-white"
                      @click="toggleFilters">
                      <span style="color: #ff823c">Все фильтры</span>
                      <app-svg id="arrow-bottom"
                        :class="{ _active: query.showAllFilters }"
                        width="12"
                        height="6" />
                    </div>
                  </div>

                  <AppButton v-if="query.route === '/'"
                    @click="goToPageAndSearch">
                    Поиск
                  </AppButton>
                </div>
              </div> -->
              <MapMainFilterYandex 
                v-if="query.showMobileMap || query.showMap"
                ref="yandexmap"
                :show-map-mobile="query.showMobileMap"
                :show-mobile-map="showMobileMap"
                @changeCurCard="changeCurCard" />
            </div>
          </div>
      </section>
      
      <template v-else>
        <EstateList v-if="route.path !== '/' && query.currentEstateType.name !== 'Новостройки'"
          :estate-list="cardData"
          :meta="cardMeta"
          :isSlider="false"
          @page-changed="onPageChanged"
          @show-more="onShowMore"
          @map-toggle="toggleMap" />
        <EstateNewList v-if="route.path !== '/' && query.currentEstateType.name === 'Новостройки'"
          :isSmall="true"
          :estate-list="cardData"
          :meta="cardMeta"
          @show-more="onShowMore"
          @page-changed="onPageChanged"
          @map-toggle="toggleMap" />
      </template>
    </div>
  </section>
</template>
<script>
import EstateList from "@/components/EstateList.vue";
import EstateNewList from "@/components/EstateNewList.vue";
import AppButton from "@/components/ui/AppButton.vue";
import FilterFloor from "@/components/filters/FilterFloor.vue";
import FilterPrice from "@/components/filters/FilterPrice.vue";
import FilterCityReactive from "@/components/filters/FilterCityReactive.vue";
import FilterReadyReactive from "@/components/filters/FilterReadyReactive.vue";
import FilterAreaReactive from "@/components/filters/FilterAreaReactive.vue";
import FilterSquareReactive from "@/components/filters/FilterSquareReactive.vue";
import FilterKitchen from "@/components/filters/FilterKitchen.vue";
import FilterNewFlat from "@/components/filters/FilterNewFlat.vue";
import FilterRoomReactive from "@/components/filters/FilterRoomReactive.vue";
import FilterCategoryReactive from "@/components/filters/FilterCategoryReactive.vue";
import FilterAllCategoryReactive from "@/components/filters/FilterAllCategoryReactive.vue";
import FIlterEstateTypeBuyOrRentReactive from "@/components/filters/FIlterEstateTypeBuyOrRentReactive.vue";
import FilterSquareAreaMeters from "@/components/filters/FilterSquareAreaMeters.vue";
import FilterPurposeReactive from "@/components/filters/FilterPurposeReactive.vue";
import FilterSquareAreaReactive from "@/components/filters/FilterSquareAreaReactive.vue";
import FilterRoadDistanceReactive from "@/components/filters/FilterRoadDistanceReactive.vue";
import FilterCountryButtons from "@/components/filters/FilterCountryButtons.vue";
import FilterZHKReactive from "@/components/filters/FilterZHKReactive.vue";
import FilterFurnish from "@/components/filters/FilterFurnish.vue";
import MapMainFilterYandex from "@/components/MapMainFilterYandex.vue";
import AppToggle from "@/components/ui/AppToggle.vue";
import TransitionTranslateLeft from "@/components/transitions/TransitionTranslateLeft.vue";
import { useFilterStore } from "@/store/filters/filterStore.js";
import { onBeforeUnmount, onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import useEmitter from "@/plugins/useEmitter.js";
import { getQuery, queryIsEmpty, setParamsInUrl } from "@/plugins/helpers.js";

import axios from "axios";

export default {
  components: {
    EstateList,
    EstateNewList,
    AppButton,
    FilterFloor,
    FilterPrice,
    FilterCityReactive,
    FilterReadyReactive,
    FilterAreaReactive,
    FilterSquareReactive,
    FilterKitchen,
    FilterNewFlat,
    FilterRoomReactive,
    FilterCategoryReactive,
    FilterAllCategoryReactive,
    FIlterEstateTypeBuyOrRentReactive,
    FilterSquareAreaMeters,
    FilterPurposeReactive,
    FilterSquareAreaReactive,
    FilterRoadDistanceReactive,
    FilterCountryButtons,
    FilterZHKReactive,
    FilterFurnish,
    MapMainFilterYandex,
    AppToggle,
    TransitionTranslateLeft,
  },
  props: {
    heroImage: {
      type: String,
      default: ""
    },
    heroTitle: {
      type: String,
      default: ""
    },
    mainLinks: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const emitter = useEmitter();
    const store = useFilterStore();
    const cardData = ref([]);
    const cardMeta = ref({});
    const { query, pageShowMore } = storeToRefs(store);
    const toggleFilters = store.toggleFilters;
    const yandexmap = ref(null);
    const curCard = ref(false);
    const changeCurCard = () => (curCard.value = !curCard.value);
    const icons = [
      'sell',
      'find',
      'change',
      'rent'
    ]

    start();
    emitter.on("toggle-map", toggleMap);
    emitter.on("load-with-params", load);
    emitter.on("clear-filter", clearFilters);

    async function load(prop) {
      const res = await store.load(route, prop);
      emitter.emit("updateSlider");
      if (yandexmap.value !== null) {
        yandexmap.value.toggleObjects();
      }

      setCardAndMeta(res);
      await store.checkScroll();

      store.scrollY = 0;

      pageShowMore.value = false;
    }

    async function start(prop) {
      store.setRoute(route.path);
      /*store.query.showMap = false;*/
      store.query.showAllFilters = false;
      await store.getOffersFilters(route, prop);
      await store.setFirstSettings(route);
      await store.getRangeForCategory(route);
      await store.setInterfaceStateAction(route);
      await load();
    }

    async function clearFilters(path) {
      document.querySelector("body").style = "overflow: auto";
      const input = document.querySelector(".estate-list__toggle-map input");
      if (input) {
        input.checked = false;
      }
      store.query.showMap = false;
      store.query.showMobileMap = false;

      if (route.path === "/" && path !== "FROM_MAIN") {
        store.scrollY = 0;
        store.setCurrentEstateTypeByCategory(store.query.category[0]);
        start();
        // await setParamsInUrl(store, route.query, { page: 1 }, "ONLY_FOR_CATEGORY_SET");
      } else if (route.path === "/" && path === "FROM_MAIN") {
        await router.push({ query: {} });
        start();
      } else {
        store.setCurrentEstateType(route.path);
        store.setSettings();
        if (path === "FROM_MAIN") {
          await router.push({ query: {} });
          start();
        }
      }
    }

    function setCardAndMeta(res) {
      cardMeta.value = res.data.meta;
      cardData.value = [...res.data.data];
    }

    async function goToPageAndSearch() {
      const query = getQuery(null, route.query);
      queryIsEmpty(route) ? await pushStandartQueryAndSearch() : await pushCurrentQueryAndSearch(query);
    }

    async function pushStandartQueryAndSearch() {
      await router.push({ path: store.getPathDependingByCategory() });
    }

    async function pushCurrentQueryAndSearch(query) {
      const path = store.getPathDependingByCategory();
      await router.push({ path: path, query: query });
    }

    async function onPageChanged(page) {
      store.saveScrollTo();
      store.setPage(page);
      await setParamsInUrl(store, route.query, {
        page: page,
      });
      emitter.emit("load-with-params");
    }

    async function onShowMore() {
      pageShowMore.value = true;

      const params = store.getParams(route.query);
      params.page = cardMeta.value.current_page + 1;

      const res = await axios.get("/api/getOffersList", {
        params: params,
      });

      res.data.data.map((el) => {
        cardData.value.push(el);
      });
      cardMeta.value = res.data.meta;

      // await setParamsInUrl(store, route.query, {
      //   page: params.page,
      // });
    }

    function showMap() {
      store.query.showMap ? (store.query.showMap = !store.query.showMap) : (store.query.showMap = true);
    }

    function showMobileMap() {
      showMap();

      if (store.query.showMobileMap) {
        store.query.showMobileMap = !store.query.showMobileMap;
        //   document.querySelector("body").style = "overflow: auto"
      } else {
        store.query.showMobileMap = true;
        //   document.querySelector("body").style = "overflow: hidden"
      }
    }

    function toggleMap(event) {
      if (event.target.checked) {
        store.query.showMap = true;
      } else {
        store.query.showMap = false;
        document.querySelector(".estate-list__toggle-map input").checked = false;
      }
    }

    function openMobileFilters() {
      store.query.filterMobileMenuIsOpen = true;
      document.querySelector("body").style = "overflow: hidden";
    }

    function closeMobileFilters() {
      store.query.filterMobileMenuIsOpen = false;
      document.querySelector("body").style = "overflow: auto";
    }

    function closeMobileFiltersAndSearch() {
      store.query.filterMobileMenuIsOpen = false;
      document.querySelector("body").style = "overflow: auto";
      if (route.path === "/") {
        goToPageAndSearch();
      }
    }

    onMounted(() => {
      /*store.query.showMobileMap = false;*/
      /*store.query.showMap = false;*/
    });

    onBeforeUnmount(function () {
      emitter.all.clear();
    });

    return {
      query,
      onPageChanged,
      onShowMore,
      toggleFilters,
      clearFilters,
      toggleMap,
      openMobileFilters,
      closeMobileFilters,
      closeMobileFiltersAndSearch,
      cardData,
      cardMeta,
      showMap,
      showMobileMap,
      goToPageAndSearch,
      route,
      curCard,
      changeCurCard,
      yandexmap,
      icons
    };
  },

  methods: {
    closeAccordions(event) {
      const accordions = this.$refs.filters.querySelectorAll(".accordion._filter-head");
      accordions.forEach((accordion) => {
        if (event.currentTarget !== accordion) {
          accordion.classList.remove("_is-open");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.reset {
  min-width: 88px;
}

.m {
  margin-left: 40px;
}

.dev-total {
  font-size: 44px;
}

.filters-section {
  position: relative;
  z-index: 10;

  &._pt {
    padding-top: 89px;

    @include phone {
      padding-top: 66px;
    }
  }

  &__content {
    // padding-top: 120px;

    @include tablet {
      padding-top: 40px;
    }
  }

  &__main-banner {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    @include phone {
      position: static;
      background-color: $color_dark-80;
    }
  }
}

.main-banner {
  position: relative;
  border-bottom-right-radius: 240px;
  overflow: hidden;
  height: 100%;

  @include phone {
    height: 430px;
    border-bottom-right-radius: 70px;
  }

  &__image {
    @include phone {
      height: 100%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__content {
    width: calc(100% - 556px);
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate3d(0, -50%, 0);
    padding: 0 170px;
    display: flex;
    align-items: center;
    justify-content: center;

    @include phone {
      width: 100%;
      padding: 0 30px;
    }

    & h2 {
      font-size: 80px;
      line-height: 90px;
      color: $white;
      text-align: center;

      @include phone {
        font-size: 32px;
        line-height: 130%;
      }
    }
  }
}

.filters-wrapper {
  display: flex;
  background: $color_dark-20;
  border-bottom-right-radius: 240px;
  position: relative;
  // overflow: hidden;

  @include laptop {
    flex-direction: column;
    border-bottom-right-radius: 0;
  }
}

.filters-icons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  @include desktop {
    padding: 28px 28px 68px;
  }

  h2 {
    font-size: 80px;
    line-height: 90px;
    margin-bottom: 48px;

    @include tablet {
      font-size: 34px;
      line-height: 120%;
      text-align: center;
    }
  }

  &__list {
    gap: 120px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    @include tablet {
      column-gap: 80px;
      row-gap: 36px;
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    gap: 24px;
    text-transform: uppercase;
    align-items: center;

    &:hover {

      .filters-icons {
        &__icon {
          display: none;
          position: absolute;
          opacity: 0;
        }

        &__icon._hover {
          position: static;
          display: block;
          opacity: 1;
        }
      }
    }

    @include tablet {
      gap: 14px;
    }
  }

  &__icon {
    width: 102px;
    height: 102px;
    background-color: transparent;
    opacity: 1;
    transition: opacity .2s ease;

    &._hover {
      display: none;
      position: absolute;
      opacity: 0;
    }
  }
}

.filters {
  $that: &;

  padding-top: 66px;
  padding-bottom: 100px;
  // position: absolute;
  // top: 0;
  // left: 0;
  width: 100%;
  max-width: 556px;
  transition: transform 0.6s cubic-bezier(0.22, 0.61, 0.36, 1);
  border-bottom-right-radius: 90px;
  background-color: $color_dark-80;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  z-index: 10;

  @include laptop {
    max-width: 100%;
  }

  @include phone {
    gap: 34px;
    padding: 40px 32px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 30px;
  }


  .mobile-filter-menu & {
    transform: translate3d(0, 0, 0) !important;

    @include laptop {
      display: block;
    }
  }

  &._map-filter {
    max-width: 556px;
    max-height: 100%;
    margin: 0;
    padding: 20px 24px 28px;
    z-index: 99;

    .mobile-filter-menu & {
      max-width: 100%;
    }
  }

  .mobile-filter-menu & {
    /*height: 100%;*/
    height: -webkit-fill-available;
    overflow: auto;
  }

  &__row,
  &__actions {
    display: flex;
    gap: 10px;
    width: 100%;

    &>* {
      flex: 1 1 50% !important;
      width: 100% !important;
      max-width: none !important;
    }
  }

  &__row-mobile {
    @include tablet {
    }

    @include phone {
      flex-direction: column;
      gap: 28px;
    }
  }

  &__wrapper {
    display: contents;
  }

  &__body,
  &__bottom {
    /*    height: 700px; // убрать*/
    // position: relative;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;

    @include tablet {
      gap: 28px;
    }
    

    ._map-filter & {
      display: block;
      padding: 0;

      *:not(.multiselect) {
        padding: 18px 0px 16px;
        border-bottom: 1px solid $color_dark-70;
      }

      *:last-child {
        border: 0;
      }

      .multiselect {
        margin: 12px -8px 20px;
        padding: 0 8px;
        position: relative;
        min-width: calc(100% + 16px);

        &::after {
          content: "";
          width: calc(100% - 16px);
          height: 1px;
          background-color: $color_dark-70;
          position: absolute;
          bottom: -4px;
          left: 8px;
        }
      }
    }
  }

  &__bottom {
    // transform: translate3d(0, -100%, 0);
    pointer-events: none;
    opacity: 0;
    position: absolute;
    width: 100%;
    z-index: -1;

    @include laptop {
      pointer-events: all;
    }

    ._show-all & {
      transform: translate3d(0, 0, 0);
      pointer-events: all;
      opacity: 1;
      position: static;
      z-index: 1;
    }

    ._map-filter & {
      transition: none;
      display: none;
      transform: none;
      opacity: 1;
    }

    ._show-all-map & {
      display: block;
      border-top: 0;
      margin-top: -8px;
      pointer-events: all;
    }
  }

  &__action-type {
    overflow: hidden;

    input {
      @include visually-hidden;
    }
  }

  &__filter {
    position: relative;
    min-width: 170px;

    @include tablet {
      max-width: 100%;
      min-width: auto;
    }

    &._checks {
      max-width: 292px;
      padding-right: 0;
      display: flex;

      * {
        border-bottom: 0 !important;
      }
    }

    &._price {
      min-width: fit-content;
      max-width: 292px;
    }

    ._map-filter & {
      max-width: 100%;
    }
  }

  &__actions-wrapper {
    padding: 0 8px !important;
    border-bottom: 0 !important;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include laptop {
      margin-bottom: 22px;
    }
  }

  &__action {
    cursor: pointer;
    color: $white;

    &::before {
      display: none;
    }

    &--show-all {
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        border-bottom: 0 !important;
      }

      border: 1px solid $color_grey-15;
      border-radius: 24px;
      padding: 0 28px;
      height: 48px;
      text-transform: uppercase;

      @include phone {
        justify-content: space-between;
        height: 32px;
        font-size: 12px;
        padding: 0 20px;
        padding-right: 10px;
      }

      svg {
        flex: none;
        margin-left: 16px;
        transition: transform 0.6s cubic-bezier(0.22, 0.61, 0.36, 1);
        padding: 0 !important;
        transform: rotate(-90deg);

        ._show-all & {
          transform-origin: center;
          transform: rotate(0);
        }
      }

      @include hover {
        text-shadow: 0 0 10px rgba(255, 255, 255, 1), 0 0 50px rgba(255, 255, 255, 0.8),
          0 0 35px rgba(255, 255, 255, 0.6), 0 0 76px rgba(255, 255, 255, 0.4), 0 0 37px rgba(255, 255, 255, 0.5),
          0 0 78px rgba(255, 255, 255, 0.4), 0 0 39px rgba(255, 255, 255, 0.3), 0 0 80px rgba(255, 255, 255, 0.2),
          0 0 35px rgba(255, 255, 255, 0.1);
      }

      &._hover-white {
        @include hover {
          text-shadow: unset;
        }

        & span {
          transition: color ease 0.3s;

          @include hover {
            color: #fff !important;
          }
        }
      }
    }

    &--go {
      .button {
        @include desktop {
          min-width: auto;
        }
      }
    }

    &--clear {
      margin-left: auto;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;

      color: #fff;

      ._map-filter & {
        margin-left: 0;
      }

      @include hover {
        color: #fff !important;

        text-shadow: 0 0 10px rgba(255, 255, 255, 1), 0 0 50px rgba(255, 255, 255, 0.8),
          0 0 35px rgba(255, 255, 255, 0.6), 0 0 76px rgba(255, 255, 255, 0.4), 0 0 37px rgba(255, 255, 255, 0.5),
          0 0 78px rgba(255, 255, 255, 0.4), 0 0 39px rgba(255, 255, 255, 0.3), 0 0 80px rgba(255, 255, 255, 0.2),
          0 0 35px rgba(255, 255, 255, 0.1);
      }
    }
  }

  &__actions {
    display: flex;

    .button {
      @include desktop {
        min-width: calc(64 / 1280 * 100vw);
        height: auto;
      }
    }
  }
}

.map {
  // margin-bottom: 68px;
  height: 800px;
  margin-top: 120px;

  @include phone {
    height: 300px;
    margin-top: 48px;
  }

  &__inner {
    @extend %container;
  }

  &__content {
    position: relative;
  }

  &__toggle {
    position: absolute;
    right: 0;
    top: -64px;
    max-width: 182px;
    z-index: 2;
  }

  &__filters {
    display: none;
    overflow: auto;
    position: absolute;
    top: 0;
    left: 0;
    background: $color_dark-90;
    width: 386px;
    border-right: 4px solid transparent;
  }

  &__yandex-map {
    height: 628px;

    .ymaps-2-1-79-gotoymaps,
    .ymaps-2-1-79-gototaxi,
    .ymaps-2-1-79-gototech,
    .ymaps-2-1-79-copyright {
      display: none !important;
    }

    .map & {
      @include laptop {
        display: none;
      }
    }

    @include phone {
      height: 100%;
      overflow: hidden;
    }
  }

  &__estate-card {
    transition: opacity 0.25s ease-in-out;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    right: 0;
    width: 336px;
    min-height: 482px;
    height: auto;

    &._is-showing {
      opacity: 1;
      pointer-events: all;
    }

    @include laptop {
      top: 38px;
    }

    &--mobile {
      @include phone {
        width: 100%;
        top: auto;
        bottom: 0;
        transform: translate3d(0, 90%, 0);
        transition: opacity 0.25s 0.1s, transform 0.3s ease-out;

        &._is-showing {
          transform: translate3d(0, 0, 0);
        }
      }
    }
  }
}

.mobile-actions {
  padding-top: 34px;

  &__inner {
    @extend %container;

    display: flex;
    justify-content: space-between;
  }

  .button {
    flex: 0 0 48%;
  }

  @media (min-width: 1280px) {
    display: none;
  }

  @include phone {
    padding-top: 24px;
  }
}

.mobile-filters {
  position: relative;
  width: 90vw;
  height: 100%;
  overflow: hidden;

  &__actions {
    padding: 0 16px;
    position: absolute;
    width: 100%;
    max-width: 320px;
    z-index: 99;
    top: 16px;
    display: flex;
    justify-content: space-between;

    .button {
      flex: 0 0 48%;
    }

    @include phone {
      max-width: 100%;
    }
  }

  @include phone {
    width: 100vw;
    height: 100%;
  }
}

.mobile-filter-menu {
  background-color: $color_dark-90;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  height: -webkit-fill-available;
  min-width: 100vw;
  min-height: 100%;
  max-height: -webkit-fill-available;
  transition: opacity 0.1s ease, transform 0.6s cubic-bezier(0, 0.55, 0.45, 1);
  display: flex;
  flex-direction: column;

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $white;
    padding: 16px 24px;
    flex: none;

    @include phone-s {
      padding: 16px 16px;
    }

    span:first-child {
      color: $color_primary;
      display: flex;
      align-items: center;
      font-size: 10px;
      line-height: 16px;
      text-transform: uppercase;

      svg {
        flex: none;
        margin-right: 12px;
      }
    }

    span:nth-child(2) {
      font-weight: 500;
      font-size: 20px;
      line-height: 26px;
    }

    span:last-child {
      font-size: 12px;
      line-height: 16px;
      text-transform: uppercase;
    }
  }

  &__body {
    height: 100%;
    flex: 1 1 0%;
  }
}

.mobile-modal-map {
  @include phone {
    display: none;
  }
  
  &._active {
    position: fixed;
    z-index: 9999;
    background: #f1f1f1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    & .mobile-actions {
      position: absolute;
      z-index: 99;
      left: 0;
      top: 20px;
      width: 100%;
      padding-top: 0;

      opacity: 1;

      transition: opacity ease 400ms, top ease-in-out 500ms;

      &._hide {
        top: -100%;
        opacity: 0;
      }
    }

    //  & .map .map__inner .map__content section #mapBlock.map-detail {
    //    height: 100vh !important;
    //  }

    & .map {
      height: 100% !important;
      width: 100%;

      &__inner,
      &__content {
        padding: 0 !important;
        height: 100%;
      }

      & .ymaps {
        height: 100% !important;
      }
    }
  }
}
</style>
